import styled from "styled-components";

const HomeStoryWrap = styled.div`
  background: linear-gradient(to top,#f6f6f6,#f6f6f6);
  padding: 72px 0;
`

export default HomeStoryWrap